
import React, { Component } from 'react';
import { Modal, Form, Input, Row, Col, InputNumber, DatePicker, TreeSelect, Divider, Table, Select, Button } from 'antd';
import moment from 'moment';
import http from '../../../axios/http';
import validator from '../../../util/validator';
import Loading from '../../ui/Loading';
import messager from '../../ui/messager';
import DictSelect from '../../ui/DictSelect';
//会员选择
import ClientSelect from './ClientSelect';
import '../../../style/common/uploadImage.css';

const FormItem = Form.Item;
const { RangePicker } = DatePicker;

//  项目及商家信息
const projectInfo = [{
    "text": "项目名称",
    "field": "buildingId",
    "buildingId": true,
}, {
    "text": "合同文本号",
    "field": "code",
}, {
    "text": "意向商户",
    "field": "clientId",
    "client": true,
    rules: [
        { required: true, message: '意向商户不能为空！' },
    ],
},
{
    "text": "经营类别及范围",
    "field": "businessCategory",
    "select": true,
    category: "MARKET_CLIENT_TYPE"
}
,{
    "text": "经营业态",
    "field": "businessDetail",
    "subSelect": true,
}
,{
    "text": "签约方",
    "field": "signatory",
}
,{
    "text": "联系人",
    "field": "partybContactInfo.name"
}
,{
    "text": "电话",
    "field": "partybContactInfo.tel",
    rules: [
        validator.tel
    ]
}
, {
    "text": "邮箱",
    "field": "partybContactInfo.mail",
    "mail": true
}, {
    "text": "地址",
    "field": "partybContactInfo.address"
}, {
    "text": "银行账号",
    "field": "partybAccount.bankAccount"
}, {
    "text": "账号名称",
    "field": "partybAccount.accountName"
}, {
    "text": "开户行",
    "field": "partybAccount.bankName"
}];

//  商务基本信息
const contractInfo = [{
    "text": "租赁区域",
    "field": "berthIds",
    "berthIds": true,
    rules: [
        { required: true, message: '租赁区域不能为空！' },
    ],
}, {
    "text": "铺位类型",
    "field": "berthType",
    "select": true,
    category: "market_berth_type"
},
// {
//     "text": "铺位面积",
//     "field": "rentArea",
//     'rentArea': true
// }, 
{
    "text": "计租面积",
    "field": "buildingArea",
    "disabled": true,
}, {
    "text": "合同起止日期",
    "field": "rentDateRange",
    rangeDate: true
}, {
    "text": "合同期（个月）",
    "field": "leaseMonth",
    "integer": true,
    "disabled": true
}, {
    "text": "计租起止日期",
    "field": "rentalDateRange",
    rangeDate: true,
    "disabled": true
}, {
    "text": "交付日期",
    "field": "deliveryDate",
    date: true,
    "disabled": true
}, {
    "text": "开业日期",
    "field": "openDate",
    date: true,
    "disabled": true
}, {
    "text": "免租期（个月）",
    "field": "freeMonth",
    "integer": true
}
];

// 其他项目信息
const otherItem = [
    {
        "text": "物业费支付周期",
        "field": "busiManageContractVO.propertyFeeCycle",
        "select": true,
        category: "berth_rent_pay_cycle",
        rules: [
            { required: true, message: '物业费支付周期不能为空！' },
        ],
    }
    ,{
        "text": "水电费每期减免金额",
        "field": "busiManageContractVO.reduceWeFees",
        "number": true,
        rules: [
            { required: true, message: '水电费每期减免金额不能为空！' },
        ],
    }
    ,{
        "text": "推广服务费(元/月.㎡)",
        "field": "busiManageContractVO.promotionFeeUnit",
        "number": true
    }
    ,{
        "text": "履约保证金(元)",
        "field": "leaseDeposit1Fee",
        "number": true
    }
]

const rentItem = [
    {
        "text": "租金方式",
        "field": "rentType",
        "select": true,
        category: "berth_rent_type"
    }
    , {
        "text": "租金支付周期",
        "field": "paymentCycle",
        "select": true,
        category: "berth_rent_pay_cycle",
        rules: [
            { required: true, message: '租金支付周期不能为空！' },
        ],
    }
]





class ContractManageEditForm extends Component {

    leaseColumns = [{
        title: '租赁年度',
        dataIndex: 'year',
        width: '13%'
    }, {
        title: "租金标准(元/㎡/月)",
        dataIndex: 'planRentPerUnit',
        width: '12%',
    }, {
        title: "标准年租金(元)",
        dataIndex: 'yearPlanRent',
        width: '15%'
    }, {
        title: '申请租金(元/㎡/月)',
        dataIndex: 'rentPerUnitDom',
        width: '15%',
    }, {
        title: '申请年租金(元)',
        dataIndex: 'yearRent',
        width: '15%',
    }, {
        title: '每年总租金差异额(元)',
        dataIndex: 'yearRentDiff',
        width: '15%',
    }, {
        title: '每年总租金达成率',
        dataIndex: 'yearRentRate',
        width: '15%'
    }, {
        title: '免租期（月）',
        dataIndex: 'freeMonth',
        width: '10%'
    }];

    busiColumns = [{
        title: '租赁年度',
        dataIndex: 'year',
        width: '13%'
    }, {
        title: "标准物管费(元/㎡/月)",
        dataIndex: 'planRentPerUnit',
        width: '12%',
    }, {
        title: "标准年物管费(元)",
        dataIndex: 'yearPlanRent',
        width: '15%'
    }, {
        title: '申请物管费(元/㎡/月)',
        dataIndex: 'rentPerUnitDom',
        width: '15%',
    }, {
        title: '申请年物管费(元)',
        dataIndex: 'yearRent',
        width: '15%',
    }, {
        title: '每年总物管费差异额(元)',
        dataIndex: 'yearRentDiff',
        width: '15%',
    }, {
        title: '每年总物管费达成率',
        dataIndex: 'yearRentRate',
        width: '15%'
    }];

    state = {
        activeKey: 'contract',
        visible: false,
        loading: false,
        berthIdsTree: [],
        berthInfo: {},
        rentStandardList: [],
        busiFeeStandardList: [],
        typeDetail: "",
        subDictList: [],
        dictList: [],
        buildingList: [],
        berthInfoMap: {},    //铺位面积，标准租金信息
        adVisiable:true,
        barrVisiable:false,
        //广告费
        advertiseInfo : [{
            "text": "合同起止日期",
            "field": "advertiseDateRange",
            rangeDate: true
        }
        ,{
            "text": "收费标准",
            "field": "advertiseFee",
            "integer": true
        }
        ,{
            "text": "广告费支付周期",
            "field": "advertiseFeeCycle",
            "select": true,
            category: "berth_advertise_pay_cycle"
        }
        ],
        //停车费
        barrierInfo : [{
            "text": "合同起止日期",
            "field": "barrierDateRange",
            rangeDate: true
        }
        ,{
            "text": "收费标准",
            "field": "barrierFee",
            "integer": true
        }
        ,{
            "text": "停车费支付周期",
            "field": "barrierFeeCycle",
            "select": true,
            category: "berth_barrier_pay_cycle"
        }
        ]
    }

    componentDidMount() {
        this.props.initEdit(this.initEdit);
        this.props.onRef(this);
        http.post({
            url: '/dict/findDict',
            data: { category: 'MARKET_CLIENT_TYPE_DETAIL' },
            success: (res) => {
                res = res == null ? [] : res;
                this.setState({ dictList: res });
            }
        });
        http.get({
            url: "/berth/findBuilding",
            success: (res) => {
                let buildingList = res == null ? [] : res;
                this.setState({ buildingList: buildingList });
            }
        });
    }

    initClientTypeDetail = (businessCategory) => {
        //如果没有闯入经营业态，默认为车商
        if (businessCategory) {
            businessCategory = "0";
        }
        let subDictList = [];
        let dictList = this.state.dictList;
        for (let i in dictList) {
            if (dictList[i].des === businessCategory) {
                subDictList.push(dictList[i]);
            }
        }
        this.setState({ subDictList: subDictList })
    }

    initEdit = (rentStandardList, busiFeeStandardList, berthIds, freeMonth) => {
        if (berthIds && berthIds !== "") {
            let berthIdArray = berthIds.split(",");
            http.get({
                url: "/berth/findBerthRentByBerthIds",
                data: { berthIds: berthIds },
                success: (res) => {
                    //初始化租金表格数据
                    this.initRentTableData(rentStandardList, berthIdArray, res, freeMonth);
                    //初始化物管费表格数据
                    this.initBussTableData(busiFeeStandardList, berthIdArray, res);
                    this.setState({
                        rentStandardList: rentStandardList,
                        busiFeeStandardList: busiFeeStandardList,
                        berthIds: berthIds,
                        berthInfoMap: res
                    });
                }
            });
        }
    }

    emptyStandardList = () => {
        this.setState({
            rentStandardList: [],
            busiFeeStandardList: [],
        });
    }
    /**
     * 初始化租金表格数据
     * @param dataList 表格数据，表格数据中包括每个时间段的起始时间和结束时间
     * @param berthIdArray 选中的商铺id（整数）数组
     * @param rentStandardMap 商铺每年的标准租金数据map，key为商铺id，value为商铺面积和商铺每年标准租金列表
     * @param freeMonth 免租月份
     */
    initRentTableData = (dataList, berthIdArray, rentStandardMap, freeMonth) => {
        const { form } = this.props;
        //年标准年租金总和
        let yearPlanRentSum = 0;
        //年租金总和
        let yearRentSum = 0;
        dataList.forEach((item, index) => {
            item["index"] = index;
            item["year"] = "第" + (index + 1) + "年";
            //设置第index+1年的月租金标准
            let planRentMonthStart = 0;
            let planRentMonthEnd = 0;
            let start = moment(item.rentStartDate);
            let startYear = start.year() + "";
            let startMonth = 12 - start.month();
            let end = moment(item.rentEndDate).add(1, "days");
            let endYear = end.year() + "";
            let endMonth = end.month();
            let totalBerthArea = 0;
            berthIdArray.forEach(berthId => {
                let berthInfo = rentStandardMap[berthId];
                if (berthInfo) {
                    //计算商铺总面积
                    totalBerthArea += berthInfo.buildingArea;
                    let berthRentList = berthInfo["rentList"];
                    if (berthRentList && berthRentList.length > 0) {
                        berthRentList.forEach(rent => {
                            if (rent.year === startYear) {
                                planRentMonthStart += rent.rent * berthInfo.buildingArea;
                            }
                            if (rent.year === endYear) {
                                planRentMonthEnd += rent.rent * berthInfo.buildingArea;
                            }
                        });
                    }
                }
            });

            //应该支付租金的月数
            let payMonth = end.diff(start, "months");
            //如果没有跨年
            if (startYear === endYear) {
                //计算年标准租金
                item["yearPlanRent"] = parseFloat((planRentMonthStart * payMonth).toFixed(2));
                //月租金除以总面积就是标准单位租金
                item["planRentPerUnit"] = (planRentMonthStart / totalBerthArea).toFixed(2);
            }
            else {
                //计算年标准租金
                item["yearPlanRent"] = parseFloat((planRentMonthStart * startMonth + planRentMonthEnd * endMonth).toFixed(2));
                //如果租期跨年，需要累计计算第一年和第二年的标准租金，再除以月数才是这个租期内的标准单位租金
                item["planRentPerUnit"] = (item["yearPlanRent"] / (payMonth * totalBerthArea)).toFixed(2);
            }

            //默认免租期分到每年
            if (index >= 0 && freeMonth) {
                //扣除免租期的月数
                payMonth = payMonth - 1;
            }
            let rentPerUnit = item["rentPerUnit"] ? item["rentPerUnit"] : 0;
            item["rentPerUnitDom"] = this.createTableDom("number", rentPerUnit, this.rentUnitChage, index);
            item["yearRent"] = parseFloat((rentPerUnit * payMonth * totalBerthArea).toFixed(2));
            item["yearRentDiff"] = (item["yearRent"] - item["yearPlanRent"]).toFixed(2);

            form.setFieldsValue({
                "leaseDeposit1Fee": parseFloat((rentPerUnit * totalBerthArea * 2).toFixed(2)),
            });

            if (item["yearPlanRent"] === 0) {
                item["yearRentRate"] = 0;
                item["rentDiscount"] = 0;
            }
            else {
                item["yearRentRate"] = (item["yearRent"] / item["yearPlanRent"] * 100).toFixed(2) + "%";
                item["rentDiscount"] = item["yearRent"] / item["yearPlanRent"];
            }
            item["freeMonth"] = index >=freeMonth?0:1;
            //月租金
            item["rental"] = rentPerUnit * totalBerthArea;
            yearPlanRentSum += item["yearPlanRent"];
            yearRentSum += item["yearRent"];
        });
        //设置总结数据
        if (dataList.length !== 0) {
            let lastItem = {};
            lastItem["index"] = dataList.length;
            lastItem["year"] = "租金合计(元)";
            lastItem["planRentPerUnit"] = "/";
            lastItem["rentPerUnitDom"] = "/";
            lastItem["yearPlanRent"] = yearPlanRentSum.toFixed(2);
            lastItem["yearRent"] = yearRentSum.toFixed(2);
            lastItem["yearRentDiff"] = (yearRentSum - yearPlanRentSum).toFixed(2);
            if (yearPlanRentSum === 0) {
                lastItem["yearRentRate"] = 0;
                lastItem["rentDiscount"] = 0;
            }
            else {
                lastItem["yearRentRate"] = (yearRentSum / yearPlanRentSum * 100).toFixed(2) + "%";
                lastItem["rentDiscount"] = yearRentSum / yearPlanRentSum;
            }
            lastItem["freeMonth"] = freeMonth;

            dataList.push(lastItem);
        }
    }

    /**
     * 初始化物管费表格数据
     * @param dataList 表格数据，表格数据中包括每个时间段的起始时间和结束时间
     * @param berthIdArray 选中的商铺id（整数）数组
     * @param rentStandardMap 商铺每年的标准租金数据map，key为商铺id，value为商铺面积等数据
     */
    initBussTableData = (dataList, berthIdArray, rentStandardMap) => {
        //年标准物管费总和
        let yearPlanRentSum = 0;
        //年物管费总和
        let yearRentSum = 0;
        dataList.forEach((item, index) => {
            item["year"] = "第" + (index + 1) + "年";
            item["index"] = index;
            let start = new moment(item.rentStartDate);
            let end = (new moment(item.rentEndDate)).add(1, "days");
            //累计选中的商铺总面积
            let totalBerthArea = 0;
            //每月的物业费
            let monthPropertyCost = 0;
            berthIdArray.forEach(berthId => {
                let berthInfo = rentStandardMap[berthId];
                if (berthInfo) {
                    //计算商铺总面积
                    totalBerthArea += berthInfo.buildingArea;
                    monthPropertyCost += berthInfo.propertyCost * berthInfo.buildingArea;
                }
            });
            //应该支付物管费的月数
            let payMonth = end.diff(start, "months");
            //计算年标准物业费 = 每月物业费 * 应支付月数
            item["yearPlanRent"] = parseFloat((monthPropertyCost * payMonth).toFixed(2));
            item["planRentPerUnit"] = (monthPropertyCost / totalBerthArea).toFixed(2);
            let rentPerUnit = item["rentPerUnit"] ? item["rentPerUnit"] : 0;
            item["rentPerUnitDom"] = this.createTableDom("number", rentPerUnit, this.busiRentUnitChage, index);
            item["yearRent"] = parseFloat((rentPerUnit * payMonth * totalBerthArea).toFixed(2));
            item["yearRentDiff"] = (item["yearRent"] - item["yearPlanRent"]).toFixed(2);
            if (item["yearPlanRent"] === 0) {
                item["yearRentRate"] = 0;
            }
            else {
                item["yearRentRate"] = (item["yearRent"] / item["yearPlanRent"] * 100).toFixed(2) + "%";
            }
            //月租金
            item["rental"] = rentPerUnit * totalBerthArea;
            yearPlanRentSum += item["yearPlanRent"];
            yearRentSum += item["yearRent"];
        });
        //设置总结数据
        if (dataList.length !== 0) {
            let lastItem = {};
            lastItem["index"] = dataList.length;
            lastItem["year"] = "物管费合计(元)";
            lastItem["planRentPerUnit"] = "/";
            lastItem["rentPerUnitDom"] = "/";
            lastItem["yearPlanRent"] = yearPlanRentSum.toFixed(2);
            lastItem["yearRent"] = yearRentSum.toFixed(2);
            lastItem["yearRentDiff"] = (yearRentSum - yearPlanRentSum).toFixed(2);
            if (yearPlanRentSum === 0) {
                lastItem["yearRentRate"] = 0;
            }
            else {
                lastItem["yearRentRate"] = (yearRentSum / yearPlanRentSum * 100).toFixed(2) + "%";
            }
            dataList.push(lastItem);
        }
    }

    // 加载铺位数据
    loadClientTree = (buildingId) => {
        let editData = this.props.editData;
        http.get({
            url: '/berth/findFloorBerth',
            data: {
                buildingId: buildingId,
            },
            success: (res) => {
                let berthInfo = {};
                if (res != null && res.length > 0) {
                    for (let item in res) {
                        res[item]["value"] = "F-" + res[item]["floorId"];
                        res[item]["title"] = res[item]["floorName"];
                        let berths = res[item]["berths"];
                        res[item]['disabled'] = true
                        if (berths != null && berths.length > 0) {
                            for (let i in berths) {
                                berths[i]["value"] = berths[i]["id"];
                                berths[i]["title"] = berths[i]["berthCode"];
                                //取消铺位框禁用
                                // berths[i]["disabled"] = berths[i]["status"] === 1;
                                if (editData.berthList !== null) {
                                    for (let index in editData.berthList) {
                                        if (editData.berthList[index] === berths[i]["id"]) {
                                            berths[i]["disabled"] = false;
                                        }
                                    }
                                }
                                berthInfo[berths[i]["id"]] = berths[i];
                            }
                        }
                        res[item]["children"] = berths;
                        delete res[item]["berths"];
                    }
                }
                this.setState({ berthIdsTree: res, berthInfo: berthInfo });
            }
        });
    }
    //根据租用面积和单位租金计算租金
    rentUnitChage = (index, value) => {
        if (isNaN(value)) {
            return
        }
        const { form } = this.props;
        let freeMonth = form.getFieldValue("freeMonth");
        let rentStandardList = this.state.rentStandardList;
        rentStandardList[index]["rentPerUnit"] = value;
        //删除最后一项统计数据
        rentStandardList.pop();
        //初始化租金表格数据
        this.initRentTableData(rentStandardList, this.state.berthIds.split(","), this.state.berthInfoMap, freeMonth);
        this.setState({ rentStandardList: rentStandardList });
    }
    //根据租用面积和单位租金计算物业费
    busiRentUnitChage = (index, value) => {
        if (isNaN(value)) {
            return
        }
        let busiFeeStandardList = this.state.busiFeeStandardList;
        busiFeeStandardList[index]["rentPerUnit"] = value;

        //删除最后一项统计数据
        busiFeeStandardList.pop();
        //初始化租金表格数据
        this.initBussTableData(busiFeeStandardList, this.state.berthIds.split(","), this.state.berthInfoMap);
        this.setState({ busiFeeStandardList: busiFeeStandardList });
    }

    // 铺位下拉选择
    berthOnChange = (value, node, event) => {
        const { form } = this.props;
        let berthInfo = this.state.berthInfo;
        let rentArea = 0;
        let buildingArea = 0;
        // 判断选中的数据的value是否等于选中后的id
        if (berthInfo !== undefined) {
            for (let item in berthInfo) {
                for (let i = 0; i < value.length; i++) {
                    if (value[i] === berthInfo[item].id) {
                        rentArea += berthInfo[item].area
                        buildingArea += berthInfo[item].buildingArea
                    }
                }
            }
        }
        let berthIds = value.join(',');
        if (berthIds !== this.state.berthIds) {
            let rentStandardList = this.state.rentStandardList;
            let busiFeeStandardList = this.state.busiFeeStandardList;
            //删除最后一项统计数据
            rentStandardList.pop();
            busiFeeStandardList.pop();
            let freeMonth = form.getFieldValue("freeMonth");
            this.initEdit(rentStandardList, busiFeeStandardList, berthIds, freeMonth);
        }
        form.setFieldsValue({
            "rentArea": rentArea,
            "buildingArea": buildingArea
        });
    }
    // 提交审核
    submitFunc = (info, e) => {
        messager.confirm("是否提交该合同？", () => {
            http.post({
                url: '/market/contract/commit',
                data: {
                    id: this.props.detailData.id
                },
                success: (res) => {
                    this.props.successCallback();
                    this.props.onCancel();
                    messager.notify("提交成功！");
                }
            });
        });
    }
    save = (type) => {
        let url = '';
        if (type === "draft") {
            // 保存草稿地址
            url = '/market/contract/save';
        } else if (type === "CONTRACT_MANAGE_COMMIT") {
            // 提交审核地址
            url = '/market/contract/commit';
        }
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            this.setState({ loadingVisible: true });
            // 处理时间格式化
            if (values["deliveryDate"] != null) {
                values["deliveryDate"] = values["deliveryDate"].format("YYYY-MM-DD");
            }
            if (values["rentalDateRange"] != null) {
                values["rentalStartDate"] = values["rentalDateRange"][0].format("YYYY-MM-DD");
                values["rentalEndDate"] = values["rentalDateRange"][1].format("YYYY-MM-DD");
            }
            if (values["rentDateRange"] != null) {
                values["rentStartDate"] = values["rentDateRange"][0].format("YYYY-MM-DD");
                values["rentEndDate"] = values["rentDateRange"][1].format("YYYY-MM-DD");
            }
            if (values["advertiseDateRange"] != null) {
                values["advertiseStartDate"] = values["advertiseDateRange"][0].format("YYYY-MM-DD");
                values["advertiseEndDate"] = values["advertiseDateRange"][1].format("YYYY-MM-DD");
            }
            if (values["barrierDateRange"] != null) {
                values["barrierStartDate"] = values["barrierDateRange"][0].format("YYYY-MM-DD");
                values["barrierEndDate"] = values["barrierDateRange"][1].format("YYYY-MM-DD");
            }

            if (values["openDate"] != null) {
                values["openDate"] = values["openDate"].format("YYYY-MM-DD");
            }

            values["id"] = this.props.editData.id;
            if (values['berthIds'] != null && values['berthIds'].length > 0) {
                values['berthIds'] = values['berthIds'].join(',');
            }

            //收费标准的处理
            let rentStandardList = this.state.rentStandardList;
            if(rentStandardList.length===0){
                messager.notify("至少1条租金收费标准");
                return
            }
            //去除最后一个统计项
            rentStandardList.pop();
            for (let index in rentStandardList) {
                rentStandardList[index]["rentStartDate"] = rentStandardList[index]["rentStartDate"].format("YYYY-MM-DD");
                rentStandardList[index]["rentEndDate"] = rentStandardList[index]["rentEndDate"].format("YYYY-MM-DD");
            }
            let leaseStandardJsonstr = JSON.stringify(this.state.rentStandardList);
            values["leaseStandardJsonstr"] = leaseStandardJsonstr;
            

            let busiFeeStandardList = this.state.busiFeeStandardList;
            if (busiFeeStandardList.length === 0) {
                messager.notify("至少1条物业收费标准");
                return
            }
            //去除最后一个统计项
            busiFeeStandardList.pop();
            for (let index in busiFeeStandardList) {
                busiFeeStandardList[index]["rentStartDate"] = busiFeeStandardList[index]["rentStartDate"].format("YYYY-MM-DD");
                busiFeeStandardList[index]["rentEndDate"] = busiFeeStandardList[index]["rentEndDate"].format("YYYY-MM-DD");
            }
            let busiRentStandardJsonStr = JSON.stringify(this.state.busiFeeStandardList);
            values["busiRentStandardJsonStr"] = busiRentStandardJsonStr;
            
            //以下部分是为了适配旧合同模板添加的内容，根据默认规则设置的字段值，如果合同模板改变，以下代码可能不再需要
            //设置租赁保证金
            // values["leaseDeposit2Fee"] = 0;
            values["leaseDepositFee"] = values["leaseDeposit1Fee"] ? values["leaseDeposit1Fee"] : 0;

            //租金收费周期的处理
            let paymentCycle = parseInt(values["paymentCycle"]);
            if (values["paymentCycle"]&&rentStandardList.length>0) {
                paymentCycle = parseInt(paymentCycle);
                values["paymentCycle"] = paymentCycle;
                //预付租金
                let prepaidRentFee = rentStandardList[0]["rentPerUnit"] * values["paymentCycle"] * values["buildingArea"];
                values["prepaidRentFee"] = prepaidRentFee;
                //预付租金的起止日期
                values["prepaidStartDate"] = values["rentStartDate"];
                values["prepaidEndDate"] = new moment(rentStandardList[0]["rentStartDate"]).add(paymentCycle, "months").add(-1, "days").format("YYYY-MM-DD");
            }

            //设置物业费收费周期
            let propertyFeeCycle = values["busiManageContractVO"]["propertyFeeCycle"];
            if (propertyFeeCycle && values["rentalDateRange"]&&busiFeeStandardList.length>0) {
                propertyFeeCycle = parseInt(propertyFeeCycle);
                values["busiManageContractVO"]["propertyFeeCycle"] = propertyFeeCycle;
                values["busiManageContractVO"]["propertyFeeStartDate"] = values["rentStartDate"];
                values["busiManageContractVO"]["propertyFeeEndDate"] = moment(values["rentStartDate"]).add(propertyFeeCycle, "months").add(-1, "days").format("YYYY-MM-DD");
                //设置
                if (values["buildingArea"]) {
                    let rentFee = busiFeeStandardList[0]["rentPerUnit"] * values["buildingArea"] * propertyFeeCycle;
                    values["busiManageContractVO"]["propertyFee"] = rentFee;
                }
            }
            //默认设置水电公摊额外收取
            values["busiManageContractVO"]["otherFeeStrategy"] = 2;
            //默认水电公摊收费周期与物业费一致
            values["busiManageContractVO"]["otherFeeCycle"] = propertyFeeCycle;

            //推广服务费
            let promotionFeeUnit = values["busiManageContractVO"]["promotionFeeUnit"];
            if (promotionFeeUnit && values["rentalDateRange"]) {
                //推广服务费收费期限，默认和物业费一致
                values["busiManageContractVO"]["promotionStartDate"] = values["rentStartDate"];
                values["busiManageContractVO"]["promotionEndDate"] = values["rentEndDate"];
                //首期推广服务费期限，默认和物业费一致
                values["busiManageContractVO"]["firstPromotionStartDate"] = values["busiManageContractVO"]["propertyFeeStartDate"];
                values["busiManageContractVO"]["firstPromotionEndDate"] = values["busiManageContractVO"]["propertyFeeEndDate"];
                values["busiManageContractVO"]["firstPromotionEndDate"] = values["busiManageContractVO"]["propertyFeeEndDate"];
                if (propertyFeeCycle && values["buildingArea"]) {
                    let rentFee = promotionFeeUnit * values["buildingArea"] * propertyFeeCycle;
                    values["busiManageContractVO"]["firstPromotionFee"] = rentFee;
                    values["busiManageContractVO"]["promotionFeeCycle"] = propertyFeeCycle;
                }
            }

            this.transferData(values, "partybAccount");
            this.transferData(values, "partybContactInfo");
            this.transferData(values, "busiManageContractVO");
            http.post({
                url: url,
                data: values,
                success: (res) => {
                    this.props.successCallback();
                    this.props.onCancel();
                    messager.notify("保存成功！");
                    this.setState({ loadingVisible: false });
                    //重新加载铺位信息
                    // this.loadClientTree(1);
                },
                error: (res) => {
                    messager.alert(res, "异常", "error");
                    this.setState({ loadingVisible: false });
                }
            });
        });
    };
    transferData = (res, field) => {
        let value = res[field];
        for (let key in value) {
            res[field + "." + key] = value[key];
        }
        delete res[field];
    }
    //字典选择改变时触发
    dictSelect = (field, dict) => {
        if (field === 'businessCategory') {
            let subDictList = [];
            let dictList = this.state.dictList;
            for (let i in dictList) {
                if (dictList[i].des === dict["code"]) {
                    subDictList.push(dictList[i]);
                }
            }
            this.setState({ subDictList: subDictList })
        }
        if (field === "clientId") {
            //选中客户改变客户业态
            const { form } = this.props;
            //修改经营业态
            if (dict.type) {
                let subDictList = [];
                let dictList = this.state.dictList;
                for (let i in dictList) {
                    if (dictList[i].des === dict.type) {
                        subDictList.push(dictList[i]);
                    }
                }
                this.setState({ subDictList: subDictList })
            }
            form.setFieldsValue({
                "partybContactInfo.name": dict.contactMan,
                "partybContactInfo.tel": dict.contactNumber,
                "partybContactInfo.mail": "",
                "partybContactInfo.address": "",
                "businessCategory": dict.type,
                "businessDetail": dict.typeDetail,
            })
        }
    }

    //所属市场下拉框改变
    selectChange = (field, value) => {
        if (field === "buildingId") {
            //重新加载铺位数据
            this.loadClientTree(value);
        }
        this.setState({ 
            advertiseInfo: [],
            adVisiable:false
         })
    }

    rangePickerChange = (field, value) => {
        if(!this.state.berthIds){
            messager.alert("请先选择租赁区域");
            return;
        }
        const { form } = this.props;
        if (field === "rentDateRange" && value !== null) {
            let end = value[1].clone().add(1, "days");
            let start = value[0].clone();
            let months = end.diff(value[0], "months");
            //计算免租期（个月）
            let daysBetween = value[1].diff(value[0], 'days');
            if(daysBetween<31){
                messager.alert("租赁时间需大于1个月");
                return
            }
            let rentalDateRange = form.getFieldValue("rentalDateRange");
            let freeMonth = 0;
            if (rentalDateRange) {
                let freeMonthEnd = rentalDateRange[0].clone().add(1, "days");
                freeMonth = freeMonthEnd.diff(value[0], "month");
            }
            form.setFieldsValue({
                leaseMonth: months,
                deliveryDate: value[0].clone(),
                rentalDateRange: [value[0].clone(), value[1].clone()],
                openDate: value[0].clone(),
                freeMonth: freeMonth
            });
            //计算租几年
            let count = months / 12;
            let rentStandardList = [];
            let busiFeeStandardList = [];
            //计算每个时间段的开始时间和结束时间
            for (let i = 0; i < count; i++) {
                let rentItem = {};
                let busiItem = {};
                months -= 12;
                rentItem.rentStartDate = start.clone().add(i * 12, "months");
                busiItem.rentStartDate = rentItem.rentStartDate;
                if (months > 0) {
                    rentItem.rentEndDate = rentItem.rentStartDate.clone().add(12, "months").add(-1, "days");
                    busiItem.rentEndDate = rentItem.rentEndDate;
                }
                else {
                    rentItem.rentEndDate = value[1].clone();
                    busiItem.rentEndDate = rentItem.rentEndDate;
                }
                //初始单位租金为0
                rentItem.rentPerUnit = busiItem.rentPerUnit = 0;
                rentStandardList.push(rentItem);
                busiFeeStandardList.push(busiItem);
            }
            let berthIdArray = this.state.berthIds.split(",");
            let berthInfoMap = this.state.berthInfoMap;
            //初始化租金表格数据
            this.initRentTableData(rentStandardList, berthIdArray, berthInfoMap, freeMonth);
            //初始化物管费表格数据
            this.initBussTableData(busiFeeStandardList, berthIdArray, berthInfoMap);
            this.setState({
                rentStandardList: rentStandardList,
                busiFeeStandardList: busiFeeStandardList
            });
        }
        if (field === "rentalDateRange" && value !== null) {
            //计算免租期（个月）
            let rentDateRange = form.getFieldValue("rentDateRange");
            let freeMonth = 0;
            if (rentDateRange) {
                let freeMonthStart = rentDateRange[0].clone().add(-1, "days");
                freeMonth = value[0].diff(freeMonthStart, "month");
            }
            form.setFieldsValue({
                openDate: value[0].clone(),
                freeMonth: freeMonth
            });
            let rentStandardList = this.state.rentStandardList;
            if (rentStandardList && rentStandardList.length > 0) {
                let berthIdArray = this.state.berthIds.split(",");
                let berthInfoMap = this.state.berthInfoMap;

                //删除最后一项统计数据
                rentStandardList.pop();
                //初始化租金表格数据
                this.initRentTableData(rentStandardList, berthIdArray, berthInfoMap, freeMonth);
                this.setState({
                    rentStandardList: rentStandardList,
                });
            }
        }
    }

    createDom = (data) => {
        let dom = [];
        for (let i = 0; i < data.length; i += 2) {
            let item = (<Row key={i}>
                <Col span={11}>
                    {this.createDomItem(data[i])}
                </Col>
                <Col span={11} offset={2}>
                    {(i + 1) < data.length ? this.createDomItem(data[i + 1]) : ''}
                </Col>
            </Row>);
            dom.push(item);
        }
        return dom;
    };
    createDomItem = (item) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let domItem = "";
        if (item.strategy === true && editData["busiManageContractVO.otherFeeStrategy"] === 1) {

        } else {
            domItem = (
                <FormItem label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue:
                                item.date ? (editData[item.field] == null || editData[item.field] === "" ? null : moment(editData[item.field]))
                                    : item.rangeDate ? (editData[item.field.substring(0, item.field.length - 9) + "StartDate"] == null
                                        || editData[item.field.substring(0, item.field.length - 9) + "StartDate"] === "" ? null
                                        : [moment(editData[item.field.substring(0, item.field.length - 9) + "StartDate"]), moment(editData[item.field.substring(0, item.field.length - 9) + "EndDate"])])
                                        : item.berthIds ? (editData[item.field] == null || editData[item.field] === "" ? null : editData[item.field].split(","))
                                            : item.buildingId ? (editData[item.field] == null || editData[item.field] === "" ? null : editData[item.field] + "")
                                                : item.client || item.select ? (editData[item.field] == null ? "" : editData[item.field] + "")
                                                    : editData[item.field],
                            valuePropName: item.radio ? 'checked' : 'value'
                        })(
                            item.select ?
                                <DictSelect category={item.category} onSelect={this.dictSelect.bind(this, item.field)} />
                                : item.subSelect ? <Select>
                                    {this.state.subDictList.map(d => <Select.Option key={d["code"]}> {d["name"]} </Select.Option>)}
                                </Select>
                                    : item.number ?
                                        <InputNumber precision={2} min={0.00} style={{ width: '100%' }} />
                                        : item.integer ?
                                            <InputNumber precision={0} min={0} style={{ width: '100%' }} disabled={item.disabled === true} />
                                                : item.date ?
                                                    <DatePicker disabled={item.disabled === true} style={{ width: '100%' }} />
                                                    : item.rangeDate ?
                                                        <RangePicker disabled={item.disabled === true} style={{ width: '100%' }} onChange={this.rangePickerChange.bind(this, item.field)} />
                                                        : item.berthIds && this.props.visible ? <TreeSelect multiple={true} treeData={this.state.berthIdsTree} treeDefaultExpandAll={true} showSearch={false} onChange={this.berthOnChange} />
                                                            : item.client ? <ClientSelect all={1} showSearch={true} onSelect={this.dictSelect.bind(this, item.field)} />
                                                                : item.buildingId ?
                                                                    <Select onChange={this.selectChange.bind(this, "buildingId")} placeholder="选择所属市场" >
                                                                        {this.state.buildingList.map(d =>
                                                                            <Select.Option key={d["id"]}>{d["buildingName"]}</Select.Option>
                                                                        )}
                                                                    </Select>
                                                                    : item.textarea ? <Input.TextArea disabled={item.disabled === true} />
                                                                        : <Input disabled={item.disabled === true} />
                        )
                    }
                </FormItem>
            );
        }
        return domItem;
    }

    /**
     * 创建编辑节点
     * @param domType 节点类型
     * @param value 操作的值,用来初始化
     * @param onChange onChange方法
     * @param index 第index行数据发生变化
     */
    createTableDom = (domType, value, onChange, index) => {
        let itemDom = (
            domType === "number" ?
                <InputNumber precision={2} min={0.00} style={{ width: '100%' }} value={value} onChange={onChange.bind(this, index)} />
                : domType === "textarea" ?
                    <Input.TextArea value={value} onChange={onChange.bind(this, index)} />
                    : <Input value={value} onChange={onChange.bind(this, index)} />
        );
        return itemDom;
    }

    render() {
        const { visible, onCancel } = this.props;

        let { busiFeeStandardList, rentStandardList } = this.state;
        busiFeeStandardList.forEach((item, index) => { item.index = index });
        rentStandardList.forEach((item, index) => { item.index = index });
        return (
            <Modal
                width={1100}
                visible={visible}
                title={<div style={{ width: '100%', textAlign: 'center', fontSize: "22px" }}>由招商营运部发起的合同审批</div>}
                okText="确定"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => {
                    this.setState({ activeKey: 'contract' });
                    this.props.form.resetFields();
                    this.setState({ rentStandardList: [{}], busiFeeStandardList: [{}] })
                }}
                footer={[
                    this.props.codeList.includes('CONTRACT_MANAGE_COMMIT') && this.props.editData.status !== "COMMIT" && this.props.editData.status !== 'AUDITED' ? <Button key="ONSELLING" type="primary" onClick={this.save.bind(this, 'CONTRACT_MANAGE_COMMIT')}>提交审核</Button> : '',
                    this.props.codeList.includes('CONTRACT_MANAGE_EDIT') && this.props.editData.status !== "COMMIT" && this.props.editData.status !== 'AUDITED' ? <Button key="draft" type="primary" onClick={this.save.bind(this, 'draft')}>保存草稿</Button> : '',
                    <Button key="cancel" type="default" onClick={onCancel}>关闭</Button>,
                ]}
            >
                <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                    <Divider orientation="left" style={{ marginTop: 0 }}>项目及商家信息</Divider>
                    {this.createDom(projectInfo)}
                    <Divider orientation="left" style={{ marginTop: 0 }}>商务基本信息</Divider>
                    {this.createDom(contractInfo)}
                    <Divider orientation="left" style={{ marginTop: 0 }}>租金收费标准</Divider>
                    <Table rowKey="index" columns={this.leaseColumns} dataSource={rentStandardList} tableLayout="fixed" pagination={false} bordered={true} style={{ marginBottom: "10px" }} />
                    {this.createDom(rentItem)}
                    <Divider orientation="left" style={{ marginTop: 0 }}>物管收费标准</Divider>
                    <Table rowKey="index" columns={this.busiColumns} dataSource={busiFeeStandardList} tableLayout="fixed" pagination={false} bordered={true} style={{ marginBottom: "10px" }} />
                    {this.createDom(otherItem)}
                    {
                        this.state.adVisiable?
                        <Divider visible="false" orientation="left" style={{ marginTop: 0 }}>广告费</Divider>
                        :""
                    }
                    
                    {this.createDom(this.state.advertiseInfo)}
                    <Divider orientation="left" style={{ marginTop: 0 }}>停车费</Divider>
                    {this.createDom(this.state.barrierInfo)}
                </Form>
                <Loading
                    visible={this.state.loadingVisible}
                    message="正在保存"
                />
            </Modal>
        );
    }
}

const ContractManageEdit = Form.create()(ContractManageEditForm);

export default ContractManageEdit;